import { MiDetailFields, MiModal } from "@miplatform/components";
import {
  BUTTON_COLORS,
  BUTTON_VARIANTS,
  ENTITY_NAMES,
} from "@miplatform/constants";
import { useEdit } from "@miplatform/hooks";
import { useIssueTemplateDetailsViewModel } from "../IssueTemplateDetails/useIssueTemplateDetailsViewModel";

export const AddNewIssueTemplateModal = ({
  onModalClose,
  onSubmit,
  loading,
  open,
  trades = [],
  assignmentTemplates = [],
}) => {
  const { initialData, prepareIssueTemplateFields } =
    useIssueTemplateDetailsViewModel();

  const issueTemplateFields = prepareIssueTemplateFields({
    assignmentTemplates,
    trades,
    isModal: true,
  });
  const edit = useEdit(initialData, issueTemplateFields);

  const handleModalClose = () => {
    onModalClose();
    edit.reset();
  };
  const handleSubmit = () => {
    onSubmit(edit.getValue());
  };

  return (
    <MiModal
      open={open}
      closeModal={handleModalClose}
      actions={[
        {
          name: "Cancel",
          variant: BUTTON_VARIANTS.TEXT,
          size: "medium",
          color: BUTTON_COLORS.BLACK,
          onClick: handleModalClose,
        },
        {
          name: "Submit",
          variant: BUTTON_VARIANTS.CONTAINED,
          size: "medium",
          color: BUTTON_COLORS.PRIMARY,
          onClick: handleSubmit,
          disabled: loading || !edit.isValid(),
        },
      ]}
      loading={loading}
      title={`Add ${ENTITY_NAMES.ISSUE_TEMPLATE}`}
      topRightClose={edit.reset}
    >
      <MiDetailFields detailFields={issueTemplateFields} edit={edit} />
    </MiModal>
  );
};
